import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  PolicyAlert,
  Title,
  Divider,
  SubmissionContainer,
  PolicyButton,
  FakeForm,
  FormText,
  FakeFormInput,
} from './MockInformationGatheringComponent.styles';

class MockInformationGatheringComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputsValid: false,
    };
  }

  async componentDidMount() {
    const { zendeskDomain, businessId, zendeskCancelDropdownId, zendeskRefundDropdownId, selectedTask } = this.props;

    if (
      (selectedTask === 'cancelOrder' && !zendeskCancelDropdownId) ||
      (selectedTask === 'refundOrder' && !zendeskRefundDropdownId)
    ) {
      return;
    }
    if (selectedTask === 'cancelOrder') {
      await this.props.hydrateZendeskDropdowns(zendeskDomain, businessId, zendeskCancelDropdownId, 'CANCEL');
    } else {
      await this.props.hydrateZendeskDropdowns(zendeskDomain, businessId, zendeskRefundDropdownId, 'REFUND');
    }
  }

  acceptPolicy() {
    this.props.setPageState('options');
  }

  generatePolicyText = () => {
    let policyText;
    if (this.props.policy) {
      policyText = <p className="policy-text">{this.props.policy}</p>;
    } else {
      // Default policy
      policyText = <p className="policy-text">This partner allows refunds and cancellations.</p>;
    }

    return policyText;
  };

  inputValid() {
    if (this.orderDateInput.value.length > 0 && this.orderNumberInput.value.length > 0) {
      this.setState({
        inputsValid: true,
      });
    } else {
      this.setState({
        inputsValid: false,
      });
    }
  }

  render() {
    const actionType = this.props.selectedTask;

    return (
      <Container>
        <div>
          <img alt="information graphic" src="/images/magnified-document.svg" />
          <Title>What is the {actionType === 'cancelOrder' ? 'cancellation' : 'refund'} policy?</Title>
          {this.generatePolicyText()}
          <Divider />
          <FakeForm>
            <div>
              <label htmlFor="order_number">Order Number: </label>
              <FakeFormInput
                id="order_number"
                onChange={() => this.inputValid()}
                ref={(input) => (this.orderNumberInput = input)}
              />
            </div>
            <div>
              <label htmlFor="order_date">Order Date: </label>
              <FakeFormInput
                id="order_date"
                onChange={() => this.inputValid()}
                ref={(input) => (this.orderDateInput = input)}
              />
            </div>
            <FormText>*if you do not have these details, please ask the customer</FormText>
          </FakeForm>
          <Divider />
          <SubmissionContainer display={this.state.inputsValid}>
            <img alt="check mark" src={'/images/checkmark-green.svg'} />
            <PolicyAlert>This order meets the condition!</PolicyAlert>
            <PolicyButton type="button" onClick={() => this.acceptPolicy()}>
              GO
            </PolicyButton>
          </SubmissionContainer>
        </div>
      </Container>
    );
  }
}

MockInformationGatheringComponent.propTypes = {
  zendeskDomain: PropTypes.string.isRequired,
  businessId: PropTypes.string.isRequired,
  zendeskCancelDropdownId: PropTypes.number.isRequired,
  zendeskRefundDropdownId: PropTypes.number.isRequired,
  selectedTask: PropTypes.string.isRequired,
};

export default MockInformationGatheringComponent;
